import DetailsGrid from '../../../../components/DetailsGrid/DetailsGrid';
import { makeStyles } from 'vendor/material';
import NumberFormat from 'react-number-format';
import SolutionIncentiveTags from '../../components/SolutionIncentiveTags';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gap: theme.spacing(2),
    paddingBlock: theme.spacing(2),
    gridTemplateColumns: '3fr 3fr 4fr',
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
      gridTemplateColumns: '1fr',
    },
    borderBottom: `1px solid ${theme.palette.NEUTRAL030}`,
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  saleDetails: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '3fr 4fr 2fr',
  },
  nameDetail: {
    display: 'grid',
    minWidth: 0,
    gap: theme.spacing(0.5),
  },
  publisher: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    color: theme.palette.NEUTRAL500,
    lineHeight: theme.typography.pxToRem(20),
  },
  incentives: {
    fontSize: `${theme.typography.pxToRem(12)} !important`,
  },
}));

const Detail = DetailsGrid.Detail;

const SolutionListItem = ({
  name,
  id,
  price,
  publisherName,
  currency,
  quantity,
  incentives,
  solutionType,
}: {
  name: string;
  id: string;
  price?: string;
  publisherName: string;
  currency: string;
  quantity: number;
  incentives?: string[];
  solutionType: '1P' | '3P' | 'SA';
}) => {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      <Detail className={classes.nameDetail} title="Solution name">
        <div>{name}</div>
        <div className={classes.publisher}>{publisherName}</div>
        <div className={classes.incentives}>
          {incentives && <SolutionIncentiveTags incentives={incentives} />}
        </div>
      </Detail>
      <Detail className={classes.ellipsis} title="Solution id">
        {id}
      </Detail>
      {solutionType === '1P' && (
        <div className={classes.saleDetails}>
          <Detail title="Quantity" align="right">
            {quantity}
          </Detail>
          <Detail title="Price per unit" align="right">
            {price ? (
              <NumberFormat
                value={price}
                displayType="text"
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : null}
          </Detail>
          <Detail title="Currency">{currency}</Detail>
        </div>
      )}
    </div>
  );
};

export default SolutionListItem;
